export const MCP_OAUTH_CHANNEL = "prea-mcp-oauth";
